import { useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const subscribe = async (e) => {
        e.preventDefault();
        if (!email) return;
        setLoading(true);
        try {
            const { data } = await api.post("/newsletter", { email });
            toast.success(data.already_subscribed ? "You're already subscribed" : "Welcome to the movement");
            setEmail("");
        } catch (err) {
            toast.error("Please enter a valid email");
        } finally {
            setLoading(false);
        }
    };

    return (
        <footer data-testid="site-footer" className="bg-[var(--navy-deep)] hairline">
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-24">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="label-mono mb-4">— NEWSLETTER</div>
                        <h3 className="serif-display text-3xl md:text-4xl mb-6 leading-tight">
                            Be first to hear when the next chapter begins.
                        </h3>
                        <form onSubmit={subscribe} className="flex items-end gap-4" data-testid="newsletter-form">
                            <input
                                type="email"
                                placeholder="your.email@world.org"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                data-testid="newsletter-email-input"
                                className="input-editorial flex-1"
                            />
                            <button className="btn-gold" disabled={loading} data-testid="newsletter-subscribe-btn" type="submit">
                                {loading ? "Sending…" : "Subscribe"}
                            </button>
                        </form>
                    </div>

                    <div className="md:col-span-3 md:col-start-7">
                        <div className="label-mono mb-4">— NAVIGATE</div>
                        <ul className="space-y-2 font-serif text-lg">
                            <li><a href="/" className="hover:text-[var(--gold)] transition-colors">Home</a></li>
                            <li><a href="/programs/cps-2026" className="hover:text-[var(--gold)] transition-colors">Climate Power Summit</a></li>
                            <li><a href="/apply" className="hover:text-[var(--gold)] transition-colors">Apply</a></li>
                            <li><a href="/contact" className="hover:text-[var(--gold)] transition-colors">Contact</a></li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="label-mono mb-4">— REACH</div>
                        <div className="font-serif text-lg space-y-2">
                            <p data-testid="footer-contact-email">connect@zsgi.org</p>
                            <p className="text-sm text-[var(--ivory)]/60 mt-4" data-testid="footer-contact-address">
                                Z ED School of Global Impact Limited<br />
                                128 City Road, London, EC1V 2NX, United Kingdom<br />
                                Company No. 17457081
                            </p>
                        </div>
                    </div>
                </div>

                <div className="hairline-b mt-16"></div>
                <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <div className="label-mono" data-testid="footer-legal-company">
                        © {new Date().getFullYear()} Z ED SCHOOL OF GLOBAL IMPACT LIMITED<br />
                        REGISTERED IN ENGLAND AND WALES | COMPANY NO. 17457081<br />
                        REGISTERED OFFICE: 128 CITY ROAD, LONDON, EC1V 2NX, UNITED KINGDOM
                    </div>
                    <div className="label-mono text-[var(--gold)]">POLICY · PEOPLE · PLANET · PEACE · PROGRESS</div>
                </div>
            </div>
        </footer>
    );
}
